export const info = {
  siteId: "2b143042-85e1-4edb-be93-ddfc87905275",
  organizationId: "c376c8fb-ed5b-418f-acd9-b9e02f6b8ff6",
};

export const defaultInfo = {
  organization: {
    name: "Fresh Food Manufacturing Sdn Bhd",
    id: "c376c8fb-ed5b-418f-acd9-b9e02f6b8ff6",
  },
  superAdmin: {
    name: "SuperAdmin",
    id: "a5e318f0-825c-43be-8b7a-4998c9c2f467",
  },
  administrator: {
    name: "Administrator",
    id: "dbf36f36-efc7-4fd0-985c-396acb561dde",
  },
  OrgAdmin: {
    id: "944ff090-990e-46bc-a955-038a61c5b0eb",
    name: "Ora Admin",
  },
  site: {
    id: "2b143042-85e1-4edb-be93-ddfc87905275",
    siteName: "Shah Alam123",
  },
  workType: {
    CM: "CM01",
    EM: "EM01",
    PM: "PM",
    PM_INS: "PM-INS01",
    OPERATION: "OPS",
    FACILITY: "FAC",
  },
};

export const SubMenu = {
  woTask: "cddc3c1a-ead8-4da1-8d86-9d334a249e95",
  woLabour: "ed9222a6-7f75-46cb-bf03-3553ddfe9de4",
  woPart: "b3848227-c74d-4198-b580-5a9cb2c1441e",
  workFlowApproval: "6006bb5d-a001-48c9-9d88-e878d585be75",
  partReservation: "4accbc53-c8c6-46f1-84ee-35b37c9effae",
  workorder: "f924c3ec-097a-41e2-a089-6e56240bc711",
};

export const dashboardStatus = {
  OPEN: "OPEN",
  OVERDUE: "OVERDUE",
  APPROVED: "APPROVED",
  APPROVEDTOCLOSE: "APPROVED TO CLOSE",
};

export const partsReservationStatus = {
  OPEN: "OPEN",
  PPRAPPR: "PPRAPPR",
  REJT: "REJT",
  RFE: "RFE",
};

export const woStatus = {
  OPEN: "OPEN",
  CLOSE: "CLOSE",
  CAN: "CAN",
  APPR: "APPR",
  REJT: "REJT",
  PPRAPPR: "PPRAPPR",
  PAPPR: "PAPPR",
  PENAPP: "PENAPP",
  PRREJT: "PRREJT",
  RESUBMIT: "RESUBMIT",
  APPTOCLOSE: "APPTOCLOSE",
  STOP: "STOP",
  COM: "COM",
  INPRG: "INPRG",
  NEW: "NEW",
  RFE: "RFE",
  WOCREATED: "WOCREATED",
};

export const DashboardIds = {
  causesReport: "8fa6e1dc-f865-4294-b2b5-8e41adea3eda",
  openWO: "48a931a3-1aa0-43c5-a3dc-97009705affd",
  failureReport: "0932dab6-1f96-4bad-8857-c5a6cf28dfa9",
  problemReport: "fb5554d8-86dd-40af-b60a-be2455a99cf8",
  correctiveReport: "25c67b69-2e24-4e4c-9851-82199083c863",
  preventiveMaintenanceHour: "9fbce1fa-557c-4f13-997d-3d41c6d14356",
  predictiveMaintenanceHour: "00084efd-6e22-432b-b816-fbf6ffbbf1f5",
  correctiveMaintenanceHour: "da854849-0969-4479-b19c-0c2987a1d928",
  proactiveKPI: "bdacaa91-ac25-40a0-bd7d-6a4bff4ec504",
  reactiveKPI: "f61e2e38-f98d-4463-8aa5-01180b206891",
  scheduleKPI: "c5f80045-e3cb-4078-926a-9fc6c0b07292",
  backlogSizeKPI: "8968c8a0-16c6-4184-98c3-53d30c9e1e8a",
  overdueWO: "89c6b346-482e-48e8-81d9-411dd619930c",
  acceptedWorkPercentageKPI: "384a7f34-c736-47b9-ae80-a1b2685838ca",
  reworkPercentageKPI: "89541e28-fe6b-4ca0-b99c-61bd9d522c0b",
  approvedWO: "40b9f4d7-fd79-4e9f-9503-d1fa2337c30c",
  approvedToCloseWO: "626bc856-95f6-4f62-b756-fcbc7818541f",
  newServiceRequest: "908488a7-3c09-4b2a-aca1-3680b7f742ec",
  labourCost: "eab5773e-e713-428f-8078-c407b5e676ec",
  mtbf: "457af25a-0e6f-4eae-a296-f1f84532d9c2",
  mttr: "ee9bb163-bbfe-49aa-97dd-2129b59b7196",
  pmCompliance: "b313c4c2-e983-4562-ba92-fc529a02cc5a",
  maintenanceKPIByWorkType: "240681dd-b333-4885-a3be-6dcc7036a671",
  maintenanceKPI: "f3058e3b-88a4-4a90-9378-a4df92ff0659",
  totalRepairHours: "0032e464-9cfa-4ece-98a4-40818b99fa8b",
  planningAccuracy: "b8ea5028-584c-480f-9abd-7d6677e62d49",
  assetStatusChart: "7304863c-c665-444f-a772-f96261481134",
  minQtyReport: "b24e1ec0-ef16-40c6-8a2e-c6e0be4a8dfa",
};
